import { Box, Stack, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SpeedIcon from "@mui/icons-material/Speed";

export default function StatCard({
  statDescription,
  stat,
  statLabel,
  comparisonPeriod,
}) {
  return (
    <Stack
      direction="column"
      alignItems="stretch"
      justifyContent="space-between "
      spacing={2}
      sx={{
        padding: 2,
        bgcolor: "white",
        borderRadius: "5px",
        border: "1px solid #0000003B",
        width: "100%",
        minWidth: "fit-content",
        height: comparisonPeriod || statLabel ? "120px" : "100px",
      }}
    >
      <Stack
        spacing="50px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box sx={{ maxWidth: "90px" }}>{statDescription}</Box>
        <Box>{stat}</Box>
      </Stack>
      {statLabel && statLabel === "Accelerated" ? (
        <Stack
          sx={{
            backgroundColor: "#FF9800",
            borderRadius: "5px",
            padding: "2px 5px",
            color: "white",
            width: "100px",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            gap: "5px",
          }}
        >
          <SpeedIcon sx={{ width: "16px", height: "16px", color: "white" }} />
          <Typography
            variant="body2"
            sx={{
              color: "white",
              fontFamily: "Roboto",
              fontStyle: "medium",
              fontWeight: "500",
              fontSize: "12px",
              lineHeight: "20px",
              letterSpacing: "0.15px",
            }}
          >
            {statLabel}
          </Typography>
        </Stack>
      ) : statLabel || comparisonPeriod ? (
          <Stack
            sx={{ color: "#00A63E" }}
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <TrendingUpIcon
              sx={{ width: "16px", height: "16px", color: "#00A63E" }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#00A63E",
                fontFamily: "Roboto",
                fontStyle: "medium",
                fontWeight: "500",
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.15px",
              }}
            >
              {statLabel} {comparisonPeriod}
            </Typography>
          </Stack>
        ) : null}
    </Stack>
  );
}
